<template>
  <div>
    <div class="wf-page-controls">
      <div class="wf-page-controls-items">
        <div class="wf-page-control-item wf-page-control-item-current-refinements">
          <pc-page-nav-back-button></pc-page-nav-back-button>
        </div>
        <div class="wf-page-control-item wf-page-control-item-product-display-controls">
          <wf-product-display-controls :show-size-control="false" :show-sort-control="false"/>
        </div>
      </div>
    </div>
    <div id="vue-collections-search-container">
      <pc-collections-search-container :collection-code="initialCollectionCode" />
    </div>
  </div>
</template>

<script>
import PcCollectionsSearchContainer from "../pc-collections-search-container.vue";
import WfProductDisplayControls from "../wf-product-display-controls.vue";
import PcPageNavBackButton from "../common/pc-page-nav-back-button.vue";

export default {
  components: {
    PcCollectionsSearchContainer,
    WfProductDisplayControls,
    PcPageNavBackButton
  },
  props: {
    initialCollectionCode: {
      type: String,
      required: true
    }
  }
};
</script>
